/***
 *
 * @param aptDate
 * @returns {string}
 */
 export function formatAcknowledgmentDate(aptDate) {
    let formattedDate = aptDate;
    try {
        const dt = new Date(aptDate);
        formattedDate = v24SchedulerCalendar.weekfromResource(dt.getUTCDay()) +
            ", " + v24SchedulerCalendar.monthfromResource(dt.getUTCMonth()) + " " + dt.getUTCDate() + ", " + dt.getUTCFullYear();
    } catch (error) {
        console.warn("Error Formatting Date on Acknowledgement", error);
    }

    return formattedDate;
}

/****
 *
 * @param dateString
 * @param startTimeStr e.g. 11:00
 * @param endTimeStr e.g. 12:00
 * @param culture
 * @param use24HrClock
 * @returns {string}
 */
export function formatTimeSlot(dateString, startTimeStr, endTimeStr, culture, use24HrClock) {
    let hourCycleFormat = use24HrClock ? "h23": "h12";
    let hourFormat = use24HrClock ? "2-digit": "numeric";
    const format = { hour: hourFormat, minute: 'numeric', hourCycle: hourCycleFormat};
    try {
        const startTime = getFormattedTime(dateString, startTimeStr, culture, format);
       
        if (endTimeStr.length > 0) {
            const endTime = getFormattedTime(dateString, endTimeStr, culture, format);
            return `${startTime} - ${endTime}`;
        }
        return `${startTime}`;
    } catch (error) {
        console.warn("Error Formatting Appointment Time ", error);
    }
}



/***
 *
 * @param dateString
 * @param timeString
 * @param culture
 * @param options
 * @returns {string}
 */
function getFormattedTime(dateString, timeString, culture, options) {
    const time = new Date(`${dateString} ${timeString}`.replace(" ", "T"));
    return time.toLocaleTimeString(culture, options);
}

export function formatDate(date) {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }


export function removeTimezone(dateStr) {
    return new Date(new Date(dateStr).getTime() + (new Date(dateStr).getTimezoneOffset() * 60 * 1000));
  }